import { Struttura } from '@hm_app/@core/models/struttura';
import { Injectable, Type } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { Questionario } from '@hm_app/@core/models/alerts';

@Injectable()
export class QuestionarioService {

    // Observable sources
    private questionario = new BehaviorSubject<Questionario>(null);

    // Observable streams
    questionarioObservable = this.questionario.asObservable();

    // Service message commands
    passQuestionario(questionario: Questionario) {
        this.questionario.next(questionario);
        // console.log(this.questionario)
    }
}
